import { createElementBlock as t, openBlock as e, createElementVNode as r } from "vue";
import n from "./index289.js";
const l = {}, s = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function p(c, o, a, m, f, i) {
  return e(), t("svg", s, o[0] || (o[0] = [
    r("path", {
      fill: "currentColor",
      d: "M11.05 3.24a7.81 7.81 0 0 1 6.028 12.777l3.452 3.453a.75.75 0 0 1-.976 1.133l-.084-.073-3.453-3.452A7.805 7.805 0 1 1 11.05 3.25l-.123.001.021-.004Zm0 1.5.102.003-.102.007a6.305 6.305 0 1 0 0 12.61 6.31 6.31 0 1 0 0-12.62Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ n(l, [["render", p]]);
export {
  u as default
};
